import * as React from "react";
import Typography from "@mui/material/Typography";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import FastForwardIcon from "@mui/icons-material/FastForward";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import { Box, Paper } from "@mui/material";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import RepeatOneIcon from "@mui/icons-material/RepeatOne";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import RepeatOnIcon from "@mui/icons-material/RepeatOn";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import TextIncreaseIcon from "@mui/icons-material/TextIncrease";
import TextDecreaseIcon from "@mui/icons-material/TextDecrease";
import RttIcon from "@mui/icons-material/Rtt";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

const style = {
  position: "absolute",
  top: "120px",
  //   top: '50%',
  left: "50%",
  transform: "translate(-50%, -50%)",
  //   bgcolor: 'background.paper',
  Opacity: 0.2,
  border: "2px solid #000",
  boxShadow: 24,
};

export default function KeysModal({ showShortcutsAction }) {
  const showComponnent = () => {
    let componnent = null;
    switch (showShortcutsAction.typeAction) {
      case "forward":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              p: 1,
              direction: "rtl",
            }}
          >
            <FastForwardIcon fontSize="large" />
            {showShortcutsAction.changeValue ? `5 seconds` : null}
          </Typography>
        );
        break;
      case "rewind":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              p: 1,
              direction: "rtl",
            }}
          >
            <FastRewindIcon fontSize="large" />
            {showShortcutsAction.changeValue ? `5 seconds` : null}
          </Typography>
        );
        break;
      case "volume":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <VolumeUpIcon fontSize="large" />
            {showShortcutsAction.changeValue}
          </Typography>
        );
        break;
      case "muted":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {showShortcutsAction.changeValue ? (
              <VolumeOffIcon fontSize="large" />
            ) : (
              <VolumeUpIcon fontSize="large" />
            )}
          </Typography>
        );
        break;
      case "playbackRate":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <SlowMotionVideoIcon fontSize="large" />
            {showShortcutsAction.changeValue}
          </Typography>
        );
        break;
      case "playPause":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {showShortcutsAction.changeValue ? (
              <PlayCircleIcon fontSize="large" />
            ) : (
              <PauseCircleIcon fontSize="large" />
            )}
          </Typography>
        );
        break;
      case "fulScreen":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {showShortcutsAction.changeValue ? (
              <FullscreenIcon fontSize="large" />
            ) : (
              <FullscreenExitIcon fontSize="large" />
            )}
          </Typography>
        );
        break;
      case "repeatPrev":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <UndoIcon fontSize="large" />
          </Typography>
        );
        break;
      case "repeat":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <RepeatOneIcon fontSize="large" />
          </Typography>
        );
        break;
      case "repeatNext":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <RedoIcon fontSize="large" />
          </Typography>
        );
        break;
      case "unlimitedRepeat":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <RepeatOnIcon fontSize="large" />
          </Typography>
        );
        break;
      case "sub1_hidden":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <LooksOneIcon />
            {showShortcutsAction.changeValue ? (
              <VisibilityOffIcon fontSize="large" color="error" />
            ) : (
              <VisibilityIcon fontSize="large" color="success" />
            )}
          </Typography>
        );
        break;
      case "sub2_hidden":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <LooksTwoIcon />
            {showShortcutsAction.changeValue ? (
              <VisibilityOffIcon fontSize="large" color="error" />
            ) : (
              <VisibilityIcon fontSize="large" color="success" />
            )}
          </Typography>
        );
        break;
      case "sub1_fontSizeIncrease":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box>
              <TextIncreaseIcon />
              <LooksOneIcon />
            </Box>
            {showShortcutsAction.changeValue}
          </Typography>
        );
        break;
      case "sub1_fontSizeIncrease":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box>
              <TextIncreaseIcon />
              <LooksOneIcon />
            </Box>
            {showShortcutsAction.changeValue}
          </Typography>
        );
        break;
      case "sub1_fontSizeDecrease":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box>
              <TextDecreaseIcon />
              <LooksOneIcon />
            </Box>
            {showShortcutsAction.changeValue}
          </Typography>
        );
        break;
      case "sub2_fontSizeIncrease":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box>
              <TextIncreaseIcon />
              <LooksTwoIcon />
            </Box>
            {showShortcutsAction.changeValue}
          </Typography>
        );
        break;
      case "sub2_fontSizeDecrease":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box>
              <TextDecreaseIcon />
              <LooksTwoIcon />
            </Box>
            {showShortcutsAction.changeValue}
          </Typography>
        );
        break;
      case "controlTimeShiftOne":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <Box>
              <LooksOneIcon />
              <RttIcon />
            </Box>
            {showShortcutsAction.changeValue} ms
          </Typography>
        );
        break;
      case "controlTimeShiftTwo":
        componnent = (
          <Typography
            id="modal-modal-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <Box>
              <LooksTwoIcon />
              <RttIcon />
            </Box>
            {showShortcutsAction.changeValue} ms
          </Typography>
        );
        break;
    }
    return componnent;
  };
  return <Paper sx={style}>{showComponnent()}</Paper>;
}
